export default __webpack_public_path__ + "static/media/hyundai.bf2ace87.png";